import { SurfaceType } from '@jms/model';
import type { SurfaceTypeDefinition } from '../../core/runtime/surfaces/surface.definition';
import { SURFACE_SCHEMA_SLOTS } from '../../core/runtime/surfaces/surface.schema.slots';

// Settings is persistence-neutral by default. Each defineSurface() mount can
// select patch, submit, or none through its saveStrategy override.
export const settingsSurface = {
  id: SurfaceType.Settings,
  saveStrategy: 'none',
  defaultFieldMode: 'edit',
  viewStatePersistence: 'none',
  slots: SURFACE_SCHEMA_SLOTS[SurfaceType.Settings],
} as const satisfies SurfaceTypeDefinition<SurfaceType.Settings>;
